// extracted by mini-css-extract-plugin
module.exports = {"root":"src-reactapp-Settings-AnnotationsModal---root"};